import { applePayButton } from "./apple-pay";
import { cardButton } from "./card";
import { googlePayButton } from "./google-pay";
import type { PaymentButton } from "./buttons.types";

export const PAYMENT_BUTTONS: readonly PaymentButton[] = [
  applePayButton,
  googlePayButton,
  cardButton,
];
